module.exports = __webpack_public_path__ + "img/van-der-mee-valentin.975f4ab9.jpg";